import { Text } from '@moda/om';
import React from 'react';

type Props = {
  className?: string;
  size: string;
  canSell: boolean;
};

export const SizeSelectorSizeLabel: React.FC<Props> = ({ className, size, canSell }) => {
  const validRegions = ['US', 'UK', 'EU', 'IT', 'FR', 'AU', 'CN'];
  const [region, value] = size.split(' ');
  // Account for "weird" sizes that don't follow the format `{region} {value}`.
  const properRegion = validRegions.includes(region) ? region : '';
  const properSizeValue = validRegions.includes(region) ? value : size;

  return (
    <Text className={className} color={canSell ? 'ink' : 'fog'}>
      {properRegion}{' '}
      <Text color={canSell ? 'ink' : 'fog'} treatment={canSell ? 'bold1' : 'body1'}>
        {properSizeValue}
      </Text>
    </Text>
  );
};
